var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50016 2.08301C6.44433 2.08301 3.9585 4.56884 3.9585 7.62467C3.9585 11.7809 9.50016 17.9163 9.50016 17.9163C9.50016 17.9163 15.0418 11.7809 15.0418 7.62467C15.0418 4.56884 12.556 2.08301 9.50016 2.08301ZM8.28891 11.583L5.53391 8.82801L6.65016 7.70384L8.28891 9.34259L12.3502 5.27342L13.4664 6.39759L8.28891 11.583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVotes);
export default __webpack_public_path__ + "static/media/votes.c4f1d348b20f63b19c06d4f08354c3c8.svg";
export { ForwardRef as ReactComponent };